<script>
    import SvelteMarkdown from 'svelte-markdown'


    export let elementData;

    const cleanMarkdown = (markdown) => {
        // Add space after series of #'s
        const cleanedMarkdown = markdown.replace(/(#+)([^#])/g, '$1 $2');
        return cleanedMarkdown;
    }

</script>

<div class="element type-text"
    style="grid-column-start: {elementData.columnStart}; grid-column-end: span {elementData.columnSpan};"
    >
    {#if elementData.type == 'text'}
        <div class="text">
            <div class="element-content">
                {#if elementData.text}
                    <SvelteMarkdown source={cleanMarkdown(elementData.text)} />
                {/if}
            </div>
        </div>
    {/if}
</div>

<style>
    .element {
        display: inline-block;
        width: 100%;
    }
</style>